export const COUNTED_ITEMS_SAVED_KEY = 'inventory.countedItems'
export const COUNTED_ITEMS_UPLOAD_RESULTS_KEY = 'inventory.countedItems.uploadResults'
